import { OrganizationInterface, OrganizationState } from '../../models/state';
import { actionTypes } from '../actions/organization';

const initialState: OrganizationState = {
  organization: {} as OrganizationInterface,
  organizations: [],
  organizationCount: 0,
  countryList: [],
};
const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ORGANIZATIONS_SUCCESS: {
      return {
        ...state,
        organizations: action.payload.rows,
        organizationCount: action.payload.count,
      };
    }
    case actionTypes.GET_ORGANIZATION_COUNTRIES_SUCCESS: {
      return {
        ...state,
        countryList: action.payload,
      };
    }
    case actionTypes.GET_ORGANIZATION_SUCCESS: {
      return {
        ...state,
        organization: action.payload,
      };
    }
    case actionTypes.UPDATE_ORGANIZATION_SUCCESS: {
      return {
        ...state,
        organization: action.payload.updatedOrganization[0],
      };
    }
    default: {
      return state;
    }
  }
};

export default organizationReducer;
